import { render, staticRenderFns } from "./AbkCvCustomCompetenceFormSection.vue?vue&type=template&id=20fcbcff&scoped=true&"
import script from "./AbkCvCustomCompetenceFormSection.vue?vue&type=script&lang=js&"
export * from "./AbkCvCustomCompetenceFormSection.vue?vue&type=script&lang=js&"
import style0 from "./AbkCvCustomCompetenceFormSection.vue?vue&type=style&index=0&id=20fcbcff&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fcbcff",
  null
  
)

export default component.exports